import type { QueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/types";
import { createOpenApiConfiguration } from "@/lib/utils";
import {
  fetchTenantAccount,
  type TenantWithRegion,
} from "@/lib/utils/tenant-account";
import { TenantApi } from "@/openapi/generated";

export async function prefetchTenantGetPublic(
  queryClient: QueryClient,
  tenantId: number,
): Promise<void> {
  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.Tenant, tenantId, "public"],
    queryFn: async () => {
      const service = new TenantApi(createOpenApiConfiguration());
      return fetchTenantAccount(
        service,
        tenantId,
        queryClient.getQueryData<TenantWithRegion>([
          QueryKeys.Tenant,
          tenantId,
          "public",
        ]),
      );
    },
    staleTime: 5 * 60 * 1000,
  });
}
